/* eslint no-console: ["error", { allow: ["warn", "error", "log"] }] */
/* global fetch, localStorage */

import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { endpoint } from '..';
import { UPDATE_TRUST_FACE_REQUEST, success, failure } from './action';

const events = (action$, state, { AjaxRequest }) =>
  action$
    .ofType(UPDATE_TRUST_FACE_REQUEST)
    .map(({ payload }) => payload)
    .mergeMap(({ personId, file }) => {
      const formData = new FormData();

      formData.append('file', file);
      return AjaxRequest.open('post', `/admin/personcustom/people/${personId}/updatetrustface`, formData, {
        noContentType: true,
      })('tudo')
        .flatMap((response) => Observable.of(success(response)))
        .catch((err) => Observable.of(failure(err)));
    });

export default combineEpics(events);
